/**
 *  Provides non-library-specific mappings to regularly used date time formats
 *
 *  @hidden
 *  currently mapped to Luxon presets, examples are as
 *  displayed here https://moment.github.io/luxon/#/formatting
 */
export enum DateTimeFormat {
    /* 10/14/1983 */
    dateShort = 'DATE_SHORT',
    /* Oct 14, 1983 */
    dateMed = 'DATE_MED',
    /* October 14, 1983 */
    dateLarge = 'DATE_FULL',
    /* Tuesday, October 14, 1983 */
    dateFull = 'DATE_HUGE',
    /* 1:30 PM */
    timeSimple = 'TIME_SIMPLE',
    /* 13:30 */
    timeSimple24 = 'TIME_24_SIMPLE',
    /* 10/14/1983, 1:30 PM */
    dateTimeShort = 'DATETIME_SHORT',
    /* Oct 14, 1983, 1:30 PM */
    dateTimeMed = 'DATETIME_MED',
}
